import { defineMessages } from "react-intl";

const PREFIX = "EmailConfirmedPage";
export default defineMessages({
  registerComplete: {
    id: `${PREFIX}.registerComplete`,
    defaultMessage:
      "Registration successfully completed. You must confirm your account. Please, check your e-mail for the confirmation link. If you haven't received an e-mail, please",
  },
  registerCompleteLinkMail: {
    id: `${PREFIX}.registerCompleteLinkMail`,
    defaultMessage: "contact your portal administrator.",
  },
});
